import { render } from "./EditBoatForm.vue?vue&type=template&id=368fe417"
import script from "./EditBoatForm.vue?vue&type=script&lang=js"
export * from "./EditBoatForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__